import { pageBySlug, resultsPage } from "./constants";

const htmlExtension = ".html";

/**
 * Posición del slug dentro del path. En Clarín la URL es
 * `deportes/estadisticas/futbol/<slug>.html`, así que el slug es el segmento 3.
 */
const clarinSlugPosition = 3;

/**
 * Traduce la URL de estadísticas al tipo de página y a los ids que necesita cada loader.
 *
 *   /deportes/estadisticas/futbol/home.html                 -> home
 *   /deportes/estadisticas/futbol/primera-a.html            -> competition
 *   /deportes/estadisticas/futbol/equipo.html?team=<id>     -> team
 *   /deportes/estadisticas/futbol/partido.html?matchId=<id> -> match
 *
 * ejemplos output: 
 * { page: match, slug: partido, competitionSlug: null, teamId: null, matchId: 123 }
 * { page: 'competition', slug: 'copa-libertadores', competitionSlug: '/copa-libertadores', teamId: null, matchId: null }
 */
export const resolveResultsRoute = ({ pathSegments = [], query = {} } = {}) => {
    const fileName = pathSegments[clarinSlugPosition] ?? null;

    if (!fileName) {
        return { page: null, slug: null, competitionSlug: null, teamId: null, matchId: null };
    }

    const slug = fileName.replace(htmlExtension, "");
    const page = pageBySlug[fileName] ?? resultsPage.competition;

    return {
        page,
        slug,
        competitionSlug: page === resultsPage.competition ? `/${slug}` : null,
        teamId: query.team ?? null,
        matchId: query.matchId ?? null,
    };
};
